export const CERTIFICATE_ERROR_MESSAGES = {
  NETWORK_ERROR:
    'Brak połączenia z siecią. Sprawdź połączenie i spróbuj ponownie.',
  UNAUTHORIZED: 'Brak uprawnień do wykonania tej operacji.',
  VALIDATION_ERROR: 'Błąd walidacji. Sprawdź dane i spróbuj ponownie.',
  INTERNAL_SERVER_ERROR: 'Wystąpił błąd serwera. Spróbuj ponownie później.',
  DEFAULT_ERROR: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Wystąpił nieoczekiwany błąd.',
} as const;
